module.exports = __webpack_public_path__ + "build/desktop/img/route.ccbc1122eeac6edb7e9bceac22d1c986.svg";